///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ValidatorFn } from '@angular/forms';

export class GtthReactiveInputBase<T> {
    value: T;
    key: string;
    label: string;
    labelSmall: string;
    required: boolean;
    disabled: boolean;
    order: number;
    controlType: string;
    containerClass: string;
    inputClass: string;
    hideInput: boolean;
    hideControl: boolean;
    options: any[];
    formGroupName: string;
    originKey: string;
    validationFn: ValidatorFn | ValidatorFn[];

    constructor(
        options: {
            value?: T;
            key?: string;
            label?: string;
            labelSmall?: string;
            required?: boolean;
            disabled?: boolean;
            order?: number;
            controlType?: string;
            containerClass?: string;
            inputClass?: string;
            hideInput?: boolean;
            hideControl?: boolean;
            formGroupName?: string;
            validationFn?: ValidatorFn | ValidatorFn[];
        } = {}
    ) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.labelSmall = options.labelSmall || '';
        this.required = !!options.required;
        this.disabled = !!options.disabled;
        this.order = options.order ?? 1;
        this.controlType = options.controlType || '';
        this.containerClass = options.containerClass || '';
        this.inputClass = options.inputClass || '';
        this.hideInput = !!options.hideInput;
        this.hideControl = !!options.hideControl;
        this.formGroupName = options.formGroupName;
        this.validationFn = options.validationFn;
    }
}
